import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import styles from "../../../layout/admin/Main.module.scss";
//共通コンポーネント
import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import Button from "../../../ui/Button";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Explanation from "../../../layout/admin/Explanation";
//専用コンポーネント
import Completion from "./Completion";
//API
import {
  postAddNoticeCategory,
  getNoticeCategory,
  postUpdateNoticeCategory,
} from "../../../../services/apiNotification";

import {
  validateMaxlength,
  validateRequired,
  validateNonNegInt,
} from "../../../../utils/validate";

const CategoryEdit = () => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  //定数；画面モード
  const displayTypeNew = "new"; //画面モード_新規
  const displayTypeUpdate = "update"; //画面モード_更新
  //URLパラメータ
  const { mode: displaytype } = useParams();
  const { id: categoryId } = useParams();
  // 確認画面
  const [isConfirmation, setIsConfirmation] = useState(false);
  // 完了フラグ
  const [isCompFlg, setIsCompFlg] = useState(false);

  //初回レンダリング
  useEffect(() => {
    (async function () {
      if (displaytype === displayTypeUpdate) {
        const ctData = await getNoticeCategory(categoryId);
        if (Object.keys(ctData).length === 0) {
          navigate("/admin/404");
          return;
        }
        setValue("updated_at", ctData.updated_at);
        setValue("category_name", ctData.category_name);
        setValue("sort_number", ctData.sort_number);
      } else {
      }
    })();
  }, []); //初回レンダリング

  //サブミットイベント
  const onSubmit = (data) => {
    if (!isConfirmation) {
      setIsConfirmation(true);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }
    if (isConfirmation) {
      if (displaytype === displayTypeNew) {
        // カテゴリ新規登録
        postAddNoticeCategory(data);
        setIsCompFlg(true);
      } else if (displaytype === displayTypeUpdate) {
        // カテゴリ更新
        postUpdateNoticeCategory(categoryId, data);
        setIsCompFlg(true);
      }
    }
  };

  //戻るボタンイベント
  const handleBack = (e) => {
    if (isConfirmation) {
      setIsConfirmation(false);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
      return;
    } else {
      //一覧画面に遷移
      navigate("../");
      return;
    }
  };

  return (
    <>
      {isCompFlg ? (
        <>
          <Completion
            subtitle="カテゴリー登録完了"
            explanation="カテゴリーの登録が完了いたしました。"
            link={"../"}
            btntext="一覧へ戻る"
          ></Completion>
        </>
      ) : (
        <div className={styles.main}>
          <ScreenTitle>お知らせ管理</ScreenTitle>
          <SubScreenTitle>
            {displaytype === displayTypeNew ? "カテゴリー新規登録" : ""}
          </SubScreenTitle>
          {isConfirmation ? (
            <Explanation>
              入力内容をご確認の上、登録ボタンを押してください。
            </Explanation>
          ) : (
            <Explanation>
              必要事項をご入力の上、確認ボタンを押してください。
            </Explanation>
          )}
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <table className={styles.input_form_table}>
              <tr>
                <TextField
                  type="hidden"
                  name="updated_at"
                  errors={errors}
                  register={register}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(30),
                    ...validateRequired(),
                  }}
                  name="category_name"
                  errors={errors}
                  label="カテゴリー名"
                  placeholder="カテゴリー名"
                  required={true}
                  isStatic={isConfirmation}
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateRequired(),
                    ...validateMaxlength(5),
                    ...validateNonNegInt(),
                  }}
                  name="sort_number"
                  errors={errors}
                  label="整列順"
                  placeholder="整列順"
                  isStatic={isConfirmation}
                  required={true}
                ></TextField>
              </tr>
            </table>

            <div className={styles.buttonbox}>
              <Button
                type="button"
                styleType="back"
                onClick={() => handleBack()}
              >
                {isConfirmation ? "変更ページへ戻る" : "一覧へ戻る"}
              </Button>
              <Button type="submit" styleType="new">
                {isConfirmation ? "登録" : "確認"}
              </Button>
            </div>
            {!isConfirmation ? (
              <div className={styles.buttonbox}>
                <Link className={styles.link} to="/admin/top">
                  トップページへ戻る
                </Link>
              </div>
            ) : (
              <></>
            )}
          </Form>
        </div>
      )}
    </>
  );
};
export default CategoryEdit;
